import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { MatSnackBar } from "@angular/material/snack-bar";
import { InvoicesService } from '../services/invoices.service';

@Component({
  selector: 'app-new-folder',
  templateUrl: './new-folder.component.html',
  styleUrls: ['./new-folder.component.css']
})
export class NewFolderComponent implements OnInit {
  newFolder!: UntypedFormGroup;
  user:any = null;
  
  constructor(
    private router: Router, 
    private formBuilder: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private invoicesService: InvoicesService
  ) { }

  ngOnInit(): void {
    this.newFolder = this.formBuilder.group({
      name:[null, Validators.required] 
    });
    this.getClientId();
    
  }
   
  async getClientId(){
  this.user = await Auth.currentAuthenticatedUser()
}

  createFolder(){
    this.invoicesService.CreateFolder({name: this.newFolder.controls.name.value, clientID:this.user.attributes.sub} )
    .then(data => {
    this.router.navigate(['invoices']);
    this.snackBar.open('SUCCESS', 'Folder is created', {
      duration: 5000,
      panelClass: ['white-snackbar']
    });
    })
    .catch(err => console.log(err))
  }
  
  close(){
    this.router.navigate(['/invoices'])
  }

}
